import React from "react";
import { Modal, ModalHeader } from "reactstrap";
import { StyledH2 } from "@aureskonnect/react-ui";

const MODAL_CLASS_NAME = "modal-wrapper-width__clz";

export type PrinterSettingModalProps = {
    isOpen: boolean;
    onClose: () => void;
    title: React.ReactNode;
    children: React.ReactNode;
    footer?: React.ReactNode;
    overlay?: React.ReactNode;
};

export function PrinterSettingModal({
    isOpen,
    onClose,
    title,
    children,
    footer,
    overlay,
}: PrinterSettingModalProps): JSX.Element {
    return (
        <Modal
            centered
            backdrop="static"
            fade={false}
            scrollable
            className={MODAL_CLASS_NAME}
            isOpen={isOpen}
            data-testid="printer-setting-modal"
        >
            <ModalHeader toggle={onClose}>
                <StyledH2 data-testid="printer-setting-modal-title">
                    {title}
                </StyledH2>
            </ModalHeader>
            {children}
            {footer}
            {overlay}
        </Modal>
    );
}
